export default __webpack_public_path__ + "static/media/screen2.9bbef755.png";